import { Link } from 'react-router-dom';
import { solutionMosaic } from '@/mocks/solution-mosaic';
import Reveal from '@/components/base/Reveal';
import SectionHeading from '@/components/base/SectionHeading';

export default function SolutionMosaic() {
  const { intro, items } = solutionMosaic;
  const [agri, parking, logistics] = items;

  return (
    <section id="solutions-mosaic" className="w-full bg-background-100 py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <Reveal>
          <SectionHeading
            title="解决方案"
            en="Solutions"
            subtitle="围绕农业、停车、物流三大高频场景，把复杂现场运行转化为可感知、可运营、可持续迭代的数字能力。"
          />
        </Reveal>

        <div className="mt-12 md:mt-16 grid grid-cols-1 lg:grid-cols-12 gap-4 md:gap-5">
          {/* 方案简介 */}
          <Reveal className="lg:col-span-5 h-full">
            <div className="flex flex-col justify-center h-full min-h-[280px] md:min-h-[400px] rounded-lg bg-foreground-950 p-7 md:p-10">
              <h2 className="font-heading font-bold text-2xl md:text-3xl text-background-50">
                {intro.title}
              </h2>
              <div className="mt-2 text-xs font-medium tracking-[0.22em] uppercase text-accent-400">
                {intro.en}
              </div>
              <p className="mt-5 md:mt-6 text-sm md:text-[15px] leading-relaxed text-foreground-300">
                {intro.desc}
              </p>
            </div>
          </Reveal>

          {/* 智慧农业 */}
          <Reveal className="lg:col-span-7 h-full" delay={100}>
            <Link
              to={agri.href}
              className="group relative block h-full min-h-[280px] md:min-h-[400px] rounded-lg overflow-hidden bg-foreground-950 cursor-pointer"
            >
              <img
                src={agri.image}
                alt={`${agri.name} · ${agri.en}`}
                title={`华辉数智 ${agri.name}解决方案`}
                className="absolute inset-0 w-full h-full object-cover object-center transition-transform duration-700 ease-out group-hover:scale-[1.05]"
              />
              <div className="absolute inset-x-0 bottom-0 h-2/3 bg-gradient-to-t from-black/80 via-black/35 to-transparent"></div>
              <div className="relative z-10 flex flex-col justify-end h-full p-6 md:p-8">
                <div className="text-[11px] md:text-xs font-medium tracking-wider text-accent-300 uppercase">
                  {agri.en}
                </div>
                <h3 className="mt-1 font-heading font-bold text-xl md:text-2xl text-background-50">
                  {agri.name}
                </h3>
                <p className="mt-1.5 text-xs md:text-sm text-background-50/75">
                  {agri.tagline}
                </p>
              </div>
            </Link>
          </Reveal>

          {/* 自由流停车 */}
          <Reveal className="lg:col-span-7 h-full" delay={100}>
            <Link
              to={parking.href}
              className="group relative block h-full min-h-[240px] md:min-h-[300px] rounded-lg overflow-hidden bg-foreground-950 cursor-pointer"
            >
              <img
                src={parking.image}
                alt={`${parking.name} · ${parking.en}`}
                title={`华辉数智 ${parking.name}解决方案`}
                className="absolute inset-0 w-full h-full object-cover object-center transition-transform duration-700 ease-out group-hover:scale-[1.05]"
              />
              <div className="absolute inset-x-0 bottom-0 h-2/3 bg-gradient-to-t from-black/80 via-black/35 to-transparent"></div>
              <div className="relative z-10 flex flex-col justify-end h-full p-6 md:p-8">
                <div className="text-[11px] md:text-xs font-medium tracking-wider text-accent-300 uppercase">
                  {parking.en}
                </div>
                <h3 className="mt-1 font-heading font-bold text-xl md:text-2xl text-background-50">
                  {parking.name}
                </h3>
                <p className="mt-1.5 text-xs md:text-sm text-background-50/75">
                  {parking.tagline}
                </p>
              </div>
            </Link>
          </Reveal>

          {/* 智慧物流 */}
          <Reveal className="lg:col-span-5 h-full" delay={200}>
            <Link
              to={logistics.href}
              className="group relative block h-full min-h-[240px] md:min-h-[300px] rounded-lg overflow-hidden bg-foreground-950 cursor-pointer"
            >
              <img
                src={logistics.image}
                alt={`${logistics.name} · ${logistics.en}`}
                title={`华辉数智 ${logistics.name}解决方案`}
                className="absolute inset-0 w-full h-full object-cover object-center transition-transform duration-700 ease-out group-hover:scale-[1.05]"
              />
              <div className="absolute inset-x-0 bottom-0 h-2/3 bg-gradient-to-t from-black/80 via-black/35 to-transparent"></div>
              <div className="relative z-10 flex flex-col justify-end h-full p-6 md:p-8">
                <div className="text-[11px] md:text-xs font-medium tracking-wider text-accent-300 uppercase">
                  {logistics.en}
                </div>
                <h3 className="mt-1 font-heading font-bold text-xl md:text-2xl text-background-50">
                  {logistics.name}
                </h3>
                <p className="mt-1.5 text-xs md:text-sm text-background-50/75">
                  {logistics.tagline}
                </p>
              </div>
            </Link>
          </Reveal>
        </div>
      </div>
    </section>
  );
}